'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

export const Impressum: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="legal-page">
            <Helmet>
                <title>{t('impressum.title')}</title>
            </Helmet>
            <div className="container">
                <div className="legal-card">
                    <h1 className="legal-title">{t('impressum.title')}</h1>
                    <p className="legal-meta">{t('impressum.updated')}</p>
                    {/* <p>{t('impressum.intro')}</p> */}
                    {/* <p>{t('impressum.legalBasis')}</p> */}

                    <section className="legal-section">
                        {/* <h3>{t('impressum.sectionTitle')}</h3> */}
                        <p className="legal-text">{t('impressum.companyBlock')}</p>
                        <p>{t('impressum.representedBy')}</p>
                        <p className="legal-text">{t('impressum.contact')}</p>
                        <p className="legal-text">{t('impressum.register')}</p>
                        <p>{t('impressum.vat')}</p>
                        <p className="legal-text">{t('impressum.contentResponsible')}</p>
                        <p className="legal-text">{t('impressum.notice')}</p>
                        <p>{t('impressum.liabilityContent')}</p>
                        <p>{t('impressum.liabilityLinks')}</p>
                        <p>{t('impressum.copyright')}</p>
                    </section>
                </div>
            </div>
        </div>
    );
};
